import './appHome.css';

import RecentExpenses from '../../../components/homeAppComponents/recentExpenses/recentExpenses';
import TotalExpenses from '../../../components/homeAppComponents/totalExpenses/totalExpenses';
import CategorizedExpenses from '../../../components/homeAppComponents/categorizedExpenses/categorizedExpenses';

export default function AppHome({loading, expenses, filteredExpenses, filteredCategories}) {
    
    return(
        <div className="app-home-container"> 
            <RecentExpenses loading={loading} expenses={expenses} filteredExpenses={filteredExpenses} filteredCategories={filteredCategories}/>
            <div className="app-home-widget-container">
                <TotalExpenses loading={loading} expenses={expenses} filteredExpenses={filteredExpenses} filteredCategories={filteredCategories}/>
                <CategorizedExpenses loading={loading} expenses={expenses} filteredExpenses={filteredExpenses} filteredCategories={filteredCategories}/>
            </div>
        </div>
    )
}